<script>
import ReportingApi from "@/services/reporting-api";
import CustomersApi from "@/services/customers-api";
import CountriesApi from "@/services/countries-api";


export default {
    props: {
      firstDay:{
          type:String,
          default:null
      },
      lastDay:{
          type:String,
          default:null
      },

  },
  mounted(){
    this.role=sessionStorage.getItem("userr");
    if(this.role==1 ){
      this.getCustomers()
    }
    this.getCountries();
    this.getPurchasesByBrand()
  },
  data () {
    return {
    salesAnalyticsDonutChart : {
      chartOptions: {
          chart: {
              type: 'donut',
              height: 200,
          },
          labels:[],
          colors: ['#f46a6a', '#2a2c74' ],//Warning changing these colors will effect the colors of the dot below
          legend: {
              show: false,
          },
          plotOptions: {
              pie: {
                  donut: {
                      size: '70%',
                  }
              }
          },
                  "yaxis": [{
          "labels": {
              "formatter": function (val) {
                  return val.toFixed(3)
              }
        }
    }]
      },
      series :[]
    },
    sum:0,
    start:this.firstDay,
    end:this.lastDay,
    role:null,
    customersList:[],
    selectedCustomer:null,
    selectedCountry:null,
    selectedCity:null,
    citiesList:[],
    countriesList:[],
    loading_sources:false,
    result:[]

    }
  },

  methods:{
    getPurchasesByBrand(){
      ReportingApi.getPurchasesByBrand(this.start,this.end,this.selectedCountry==null ? null : this.selectedCountry.id,this.selectedCity==null ? null : this.selectedCity.id,this.selectedCustomer==null ? null : this.selectedCustomer.id).then(

        (result)=>{
          if(result){
            this.loading_sources=true
            this.result=result.list
            this.salesAnalyticsDonutChart.chartOptions.labels=[]
            this.salesAnalyticsDonutChart.series=[]
            this.sum=result.sumStr
            for(const i in this.result){
              this.salesAnalyticsDonutChart.chartOptions.labels.push(this.result[i].brandName)
              this.salesAnalyticsDonutChart.series.push(this.result[i].total==null ? 0 : this.result[i].total )
              this.result[i].color= this.ColorToIconClass(this.salesAnalyticsDonutChart.chartOptions.colors[i])
            }
            
          }
          
        }
        
      )
    },
    getCustomers(){
      CustomersApi.getCustomers(this.selectedCountry==null ? null : this.selectedCountry.id,this.selectedCity==null ? null : this.selectedCity.id).then(
        response => {
          this.customersList=response;
        }
      )
    },
    getCountries(){
       CountriesApi.getCountries().then(
          result => {
            this.countriesList = result
        })
     },
    getCities(){
       CountriesApi.getCities(this.selectedCountry ? this.selectedCountry.id : null).then(
          result => {
            this.citiesList = result
        })
     },
     ColorToIconClass(color){
        switch(color) {
        case "#2a2c74": return 'primary';
        case "#f46a6a": return 'danger';
        default: return 'primary';
      }
     }
  },
    watch: {
        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getPurchasesByBrand()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getPurchasesByBrand()

          }
        },
        selectedCountry: function(){
          this.getPurchasesByBrand()
          this.getCustomers()
          if(this.selectedCountry != null){
            this.getCities()
          }else{
            this.selectedCity=null
            this.citiesList=[]
          }
        },
        selectedCity: function(){
            this.getCustomers()
            if(this.selectedCountry!=null){
              this.getPurchasesByBrand()
            }
        },
        selectedCustomer: function(){
          this.getPurchasesByBrand()

        }
    }
  
}
</script>
<template>
  <div class="clearfix m-4">
    <div class="row">
      <div class="col-11">
          <h4 class="card-title mb-2 font-size-18 font-weight-bold text-primary">{{role==0 ? $t("reporting.customer.purchaseVolume.title") : $t("reporting.supplier.purchaseVolume.title")}}  <span class="font-size-12"> ({{$t('amounts.withoutTaxes')}})</span></h4>
      </div>
    </div>
      <div v-if="role==1"  class="row mt-4">
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
              <b-form-group label="" label-for="">
                  <v-select :options="countriesList" :placeholder="$t('lists.countries.label')" label="name" v-model="selectedCountry">
                  <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                  </v-select>
              </b-form-group>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
              <b-form-group label="" label-for="">
                  <v-select :options="citiesList" :placeholder="$t('lists.cities.label')" label="name" v-model="selectedCity">
                  <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                  </v-select>
              </b-form-group>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
              <b-form-group label="" label-for="">
                  <v-select :options="customersList" :placeholder="$t('lists.customers.label')" label="companyName" v-model="selectedCustomer">
                  <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                  </v-select>
              </b-form-group>
          </div>
      </div>
      <div class="row text-center" :class="role==1 ? '' : 'mt-4' " >
          <div class="col-xl-6 col-lg-6 col-md-12 col-cm-12 col-xs-12 pr-lg-2">
            <b-form-group  label-for="">
              <b-form-datepicker
                v-model="start"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
              ></b-form-datepicker>
            </b-form-group>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-cm-12 col-xs-12">
            <b-form-group  label-for="">
              <b-form-datepicker
                v-model="end"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
              ></b-form-datepicker>
            </b-form-group>
          </div>
      </div>
      <div class="row mt-4 ">
        <div class="col-2"/>
        <div class="col-8 text-center">
          <p  v-if="role==0" class="text-center font-size-20">{{$t("reporting.customer.purchaseVolume.label")}}</p>
          <p v-else class="text-center font-size-20"> {{ $t("reporting.supplier.purchaseVolume.label1")}}  <span class="font-weight-bold"> {{ $t("reporting.supplier.purchaseVolume.labelBold")}} </span> {{$t("reporting.supplier.purchaseVolume.label2") }} : </p>
        </div>
        <div class="col-2"/>
      </div>
      <div class="row ">
        <div class="col-2"></div>
        <div class="col-8 text-center">
          <h3 class="text-success">{{this.sum}} </h3>

        </div>
        <div class="col-2"></div>

      </div>
      <div>
        <apexchart
        v-if="loading_sources"
          class="apex-charts"
          height="200"
          :series="salesAnalyticsDonutChart.series"
          :options="salesAnalyticsDonutChart.chartOptions"
        ></apexchart>
      </div>
          <div class="text-center text-muted">
              <div  class="row">
                <div v-for="data in this.result" :key="data.brandName" class="col-6">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle mr-1" :class="'text-'+data.color"></i>
                      {{data.brandName}}
                    </p>
                    <h5>{{data.totalStr==null ? 0 : data.totalStr}} </h5>
                  </div>
                </div>
              </div>
      </div>

      
  </div>
</template>

